module.exports = __webpack_public_path__ + "static/img/video-title.c1dc788.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/video-title.png
// module id = /KNy
// module chunks = 1